<template>
  <tr>
    <td class="cursor-pointer" @click="toggleView">{{ capitalizeWords(view) }}</td>
    <td v-for="(value, key) in actions" :key="`${value}_${key}`">
      <v-checkbox v-if="selectedTag && permissions[view].includes(value)"
                  dense
                  hide-details
                  :ripple="false"
                  v-model="edit[view]"
                  :value="`${value}`"
      ></v-checkbox>
      <v-checkbox v-if="!selectedTag && permissions[view].includes(value)"
                  dense
                  hide-details
                  :ripple="false"
                  v-model="edit[view]"
                  :value="`${value}`"
                  @change="addAction()"
      ></v-checkbox>
    </td>
  </tr>
</template>

<script>
import {mapMutations, mapState} from "vuex";
import {PermissionsConstants} from "@/permissions";

export default {
  name: "UserPermissionsTagTableRow",
  props: ['view', 'selectedTag', 'edit'],
  data() {
    return {
      actions: PermissionsConstants,
    }
  },
  computed: {
    ...mapState('user', ['permissions']),
  },
  methods: {
    ...mapMutations('userPermissions', ['setAddNewTag']),
    async addAction(){
      await this.setAddNewTag(this.edit)
    },
    capitalizeWords(arr) {
        arr = arr.replaceAll('_', ' ')
        return arr.charAt(0).toUpperCase() + arr.slice(1).toLowerCase();
    },
    toggleView() {
      let permissions = this.edit[this.view];
      if (permissions.length > 0) {
        permissions.splice(0, permissions.length);
        this.setAddNewTag(this.edit)
      } else {
        this.permissions[this.view].forEach(ap => {
          if (!permissions.includes(ap)) {
            permissions.push(ap);
            this.setAddNewTag(this.edit)
          }
        });
      }
    },
  }
}
</script>

<style scoped>
.checkbox-row {
  display: flex;
  flex-direction: row
}

.checkbox-padding {
  padding-right: 20px;
}

.cursor-pointer {
  cursor: pointer;
}
</style>